// extracted by mini-css-extract-plugin
module.exports = {"list":"customList_list__3-EjI","blur":"customList_blur__1j35M"};